var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructorsMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.457 47.727v-4.545a9.09 9.09 0 00-9.09-9.091H18.183a9.09 9.09 0 00-9.09 9.09v4.546M27.276 25a9.09 9.09 0 100-18.182 9.09 9.09 0 000 18.182z",
    stroke: "#000",
    strokeWidth: 4.545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.234 18.395c.401 0 .727.325.727.727v3.761c0 .393.318.712.711.712h3.188a1.3 1.3 0 010 2.6h-3.188a.711.711 0 00-.71.71V30.095a1.3 1.3 0 11-2.6 0v-3.189a.712.712 0 00-.713-.71h-3.76a.727.727 0 01-.728-.728v-1.082a.79.79 0 01.79-.79h3.699a.712.712 0 00.711-.712v-3.698a.79.79 0 01.79-.79h1.083z",
    fill: "#000"
  })));
}
export default SvgInstructorsMarket;